import { useTailwind } from "tailwind-rn";

export default useTailwind;